(async () => {
  const deferredMedia = Array.from(
    document.querySelectorAll('product-info media-gallery deferred-media')
  ).find((element) =>
    element.querySelector('template')?.content.querySelector('video')
  );

  if (!deferredMedia) {
    console.log('Inline deferred product video not found');
    return;
  }

  deferredMedia.style.setProperty('display', 'block');
  deferredMedia.style.setProperty('width', '100%');

  const modalOpener = deferredMedia.previousElementSibling;

  if (modalOpener?.matches('modal-opener.product__modal-opener--video')) {
    modalOpener.style.setProperty('display', 'none');
  }

  deferredMedia.querySelector(':scope > video')?.remove();

  const video = deferredMedia
    .querySelector('template')
    .content.querySelector('video')
    .cloneNode(true);

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.preload = 'auto';
  video.poster = '';
  video.controls = false;
  video.removeAttribute('controls');
  video.removeAttribute('poster');
  video.setAttribute('muted', '');
  video.setAttribute('loop', 'true');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  video.style.setProperty('transform', 'translateZ(0)');
  video.style.setProperty('-webkit-transform', 'translateZ(0)');
  video.style.setProperty('will-change', 'transform');

  deferredMedia.appendChild(video);
  deferredMedia.setAttribute('loaded', 'true');

  void deferredMedia.offsetHeight;
  video.load();

  await new Promise((resolve, reject) => {
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      resolve();
      return;
    }

    video.addEventListener('loadeddata', resolve, { once: true });
    video.addEventListener('error', reject, { once: true });
  });

  await new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });

  video.currentTime = 0.01;
  await video.play();

  console.log('Fresh Safari inline video started', {
    paused: video.paused,
    currentTime: video.currentTime,
    readyState: video.readyState,
  });
})();